import React, { Component } from 'react';
import {connect} from 'react-redux';
import {Snackbar} from "material-ui";
import {SnackBarActions} from "../../actions/snackbar.actions";

class AppSnackbar extends Component{

    resetSnackbar = () => {
        this.props.dispatch(SnackBarActions.displayMessage(undefined))
    };

    render(){
        const {message} = this.props;
        return (
            <div>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={message !== undefined}
                    autoHideDuration={5000}
                    onClose={this.resetSnackbar}
                    message={message}
                />
            </div>
        )
    }
}

function state2props(state){
    return {
        message: state.Snackbar.message
    }
}

export default connect(state2props)(AppSnackbar);


// WEBPACK FOOTER //
// ./src/shared/Snackbar/AppSnackbar.js